import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * VAT price-tag icon used in the main menu.
 * Keeps standard MUI icon sizing.
 */
const VatIcon: React.FC<SvgIconProps> = (props) => {
  const vatIconUrl = 'https://cdn-icons-png.flaticon.com/512/9766/9766747.png';

  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <image
        href={vatIconUrl}
        width="24"
        height="24"
        preserveAspectRatio="xMidYMid meet"
      />
    </SvgIcon>
  );
};

export default VatIcon;
